(async () => {
    const activitySearchContainers = document.querySelectorAll('[data-activity-search]');

    if (activitySearchContainers.length) {
        await import('/components/activity-search/activity-search-lazy.js');
    }
})();
